import "../styleSheets/socialResponsibility.css";
import { useTranslation } from "react-i18next";

function SocialResponsibility() {
  const { t } = useTranslation("common");

  return (
    <section className="section-social" aria-labelledby="social-responsibility-title">
      <div className="section-social-text-container">
        <div className="preserving-stories-container">
          <div className="preserving-stories-title-area">
            <h2 id="social-responsibility-title" className="preserving-stories-title">
              {t("pageBody.socialResponsibility.preservingStories")}
            </h2>
            <p className="preserving-stories-subtitle">
              <b>{t("pageBody.socialResponsibility.sharingHumanity")}</b>
            </p>
          </div>
          <div className="divider" />
          <div className="preserving-stories-message-container">
            <p className="preserving-stories-text">
              {t("pageBody.socialResponsibility.commitment")}
            </p>
            <br />
            <p className="preserving-stories-text">
              {t("pageBody.socialResponsibility.volunteer")}
            </p>
          </div>
        </div>
      </div>
      <div className="preserving-stories-image-section">
        <div className="preserving-stories-image" />
      </div>
    </section>
  );
}
export default SocialResponsibility;
